/**
 * Positions a element relative to the bottom of the element such that the width
 * of the element is the same as the reference element.
 * @param {HtmlElement} element - The element to position.
 * @param {HtmlElement} refElement - The element to position relative to.
 */
export function positionRelativeTo(element, refElement){
	var rect = refElement.getBoundingClientRect();

	var adjustX = 0;
	var adjustY = 0;

	var style = getComputedStyle(document.body);

	if (style.position !== 'static'){
		let bodyRect = document.body.getBoundingClientRect();
		adjustX = bodyRect.left;
		adjustY = bodyRect.top;
	}
	
	var x = rect.left + window.scrollX - adjustX;
	var y = rect.bottom + window.scrollY - adjustY;
	var width = width = rect.width;

	element.style.left = x + 'px';
	element.style.top = y + 'px';
	element.style.width = width + 'px';
}